import { useEffect, useState } from 'react'
import boldFont from '../../../styles/fonts/sf-pro-display_bold.woff2'
import mediumFont from '../../../styles/fonts/sf-pro-display_medium.woff2'
import regularFont from '../../../styles/fonts/sf-pro-display_regular.woff2'
import semiBoldFont from '../../../styles/fonts/sf-pro-display_semibold.woff2'
import { useLogo } from '../../common/hooks/useLogo'
import useViewport from '../../common/hooks/useViewport'
import { Element } from '../../common/html/element'
import { Image } from '../../common/image'
import EventEmitter, { SHOW_LOADING_SCREEN } from '../../helpers/EventEmitter'
import classes from './index.module.scss'

const fontFaces = [
  { weight: 400, font: regularFont },
  { weight: 500, font: mediumFont },
  { weight: 600, font: semiBoldFont },
  { weight: 700, font: boldFont },
]

export const LoadingScreen = ({ children }) => {
  const { width, height } = useViewport()
  const logo = useLogo()

  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    let timeOut = null

    Promise.all(
      fontFaces.map((fontFace) => {
        return new FontFace('SFProDisplay', `url(${fontFace.font})`, {
          weight: fontFace.weight,
        }).load()
      }),
    ).then((fonts) => {
      timeOut = setTimeout(() => {
        setIsShow(true)
        fonts.forEach((font) => {
          document.fonts.add(font)
        })
      }, 100)
    })

    EventEmitter.subscribe(SHOW_LOADING_SCREEN, setIsShow)

    return () => {
      EventEmitter.unsubscribe(SHOW_LOADING_SCREEN, setIsShow)

      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [])

  if (isShow) {
    return children
  }

  return (
    <Element
      className="flexColumn justifyContentCenter alignItemsCenter"
      style={{ backgroundColor: '#F3F3F3', width, height }}
    >
      <div className={classes.logo}>
        <Image src={logo} alt="Logo" style={{ width: 147, height: 36 }} />
      </div>
      <Element
        className={classes.loadingBox}
        style={{ backgroundColor: '#C8E3FF' }}
      >
        <Element
          className={classes.loader}
          style={{
            background: 'linear-gradient(45deg, #C8E3FF, #0553A5)',
          }}
        />
      </Element>
    </Element>
  )
}
